import { getSectionHeadingPath } from '@utils/apiFunctions';
import httpClient from '@utils/httpClient';
import { pathTypes } from '@utils/sectionEnums';

export function fetchPodcastItemsApiCall(blockId) {
  return httpClient.get(`api/podcast-blocks/${blockId}/items`);
}

export function sortPodcastItemsApiCall(blockId, items) {
  return httpClient.put(`api/podcast-blocks/${blockId}/items/sort`, { items });
}

export function fetchPodcastAlbumsApiCall(blockId) {
  return httpClient.get(`api/podcast-blocks/${blockId}/albums`);
}

export function createPodcastAlbumApiCall(blockId, title, image = null) {
  return httpClient.post(`api/podcast-blocks/${blockId}/albums`, { Title: title, Image: image });
}

export function updatePodcastAlbumApiCall(blockId, albumId, title, image = null) {
  return httpClient.put(`api/podcast-blocks/${blockId}/albums/${albumId}`, { Title: title, Image: image });
}

export function deletePodcastAlbumApiCall(blockId, albumId) {
  return httpClient.delete(`api/podcast-blocks/${blockId}/albums/${albumId}`);
}

export function updatePodcastApiCall({
  id,
  isPathDesign,
  headingTitle,
  headingDescription,
  headingTextAlign,
  headingImage,
  headingDivider,
  containerDesign,
  itemDesign,
  buttonDesign,
  view,
  layout,
}) {
  return httpClient.put(getSectionHeadingPath(pathTypes.podcast, isPathDesign), {
    id,
    headingTitle,
    headingDescription,
    headingTextAlign,
    headingImage,
    headingDivider,
    containerDesign,
    itemDesign,
    buttonDesign,
    view,
    layout,
  });
}
